import { AuthLayout } from "../components/templates/AuthLayout.tsx";
import { LoginForm } from "../components/organisms/LoginForm.tsx";

export function LoginPage() {
  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  );
}
